import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import FileSaver from 'file-saver';

import * as THREE from '../chapter3/three';
import PostProcessing from '../chapter3/postprocessing';

import Iconset from '../icons';

import '../../styles/chapter3/artwork-generator.scss';

import background_image from '../../images/generator/prevprevprev.jpg';
import normalImage from '../../images/generator/normal.jpg';

const bg_colors = [
  "#DF6F75", 
  "#D18447", 
  "#76C16C", 
  "#52D0C6", 
  "#5667D5", 
  "#E965C6", 
]

const config = {
	background:"prevprevprev.jpg",
  device : 'desktop',
  devicePixelRatio : window.devicePixelRatio,
	canRotate:false,
	imagesPath:"media/assets/images",
	isDebugGUI:true,
	normal:"normal.jpg",
	saveImageSize:1024,
	normaltex_url : normalImage,
	backgroundtex_url : background_image,
	size : 256,
}

class GeneratorElement extends React.Component{

	constructor(props){
		super(props);
    this.state = {
      mouse_strength : 0.033,
      mouse_strength_bool : true,//  hard | soft mode
      cSize : 70,
      cSize_bool : true,//  hard | soft mode
      color : 0,
      showSidebar : false,
      paused : false,
      showHint : false,
      hintWasVisible : false,
      showMobileUI: false,
      currentColor : 0,

    }

    this.offset = {
      left : 0,
      top : 0,
    }
    
    this.internalCount = 0;
    this.config = config;

 }


  componentDidMount(){
     this.renderer = new THREE.WebGLRenderer({
      alpha: true,
      premultipliedAlpha: true,
      antialias: true
    });

    this.isCapable = this.renderer.extensions.get('OES_texture_half_float_linear') || this.renderer.extensions.get('OES_texture_float_linear');

    //testcase
    //this.isCapable = null;

    if(this.isCapable != null){
      this.isCapable = true;
    }else{
      this.isCapable = false;
    }
   
    this.w = this.container.offsetWidth;
    this.h = this.container.offsetHeight;

    this.initScene();

    // this.addEvents();

    this._controller = {
      color: 0x0050ff,
    };

    this.originalcamera = new THREE.PerspectiveCamera(50, this.container.offsetWidth / this.container.offsetHeight, 0.0001, 100);
    this.originalcamera.position.set(0, 0, config.device == 'desktop'  ? 5 : 6);

    this.camera = new THREE.OrthographicCamera(1, 1, 1, 1, -10000, 10000);

    this.passes = [];

    this.addEvents();

    setTimeout(()=>{

      this.setState({
        showSidebar : true
      });

    },1500);

  }


  componentWillUnmount(){
    cancelAnimationFrame(this.loop);
    this.removeEvents();
  }
	//_________ end of didMount

	initScene() {

    this.scene = new THREE.Scene();

    this.renderer.setClearColor(0x000000, 0.0);

    this.renderer.setSize(this.w, this.h);
    this.renderer.setPixelRatio(config.devicePixelRatio);

    this.camera = new THREE.PerspectiveCamera(50, this.container.offsetWidth / this.container.offsetHeight, 0.0001, 100);
    this.camera.position.set(0, 0, config.device == 'desktop'  ? 5 : 6);

    this.secondcamera =  new THREE.PerspectiveCamera( 50, 1, 0.0001, 100);

    this.secondcamera.position.set(0, 0, config.device == 'desktop'  ? 5 : 6);

    this.secondcamera.updateProjectionMatrix();

    this.canvas = this.renderer.domElement;

    this.container.appendChild( this.canvas );

    this.posteffect = new PostProcessing(this.scene,this.camera, this.renderer,this.config,()=>{
   
      this.loop = this.update();
      this.onResize();

      this.props.generatorReady();
     
    });

    
  }

  convertCanvasToImage(blob,title,cb) {
    var filesaver = new FileSaver.saveAs(blob, title + ".png");
      filesaver.onwriteend = ()=>{
        cb();
      }

  }


  posteffectupdate() {

    this.posteffect.render(this.scene, this.camera);

  }

    //__________________________________________________ EVENT


  checkHint(){
    this.internalCount++;
    if(this.internalCount > 2 && !this.state.hintWasVisible){
      this.setState({
        showHint : true
      });
    }
  }

  toggleMobileUI(){
    this.setState({
      showMobileUI : !this.state.showMobileUI
    });
  }

  onMouseDown(event) {
    this.checkHint();
    if(this.state.paused){
      this.toggleLoop();
    }
    this.isDown = true;
    
  }

  onMouseUp() {
    this.isDown = false;
  }


  transformMouse(x,y){
    if(this.isDown){
        this.posteffect.mouse.x = x;
        this.posteffect.mouse.y = y;
        this.posteffect.originalmouse.x = ( x / this.w ) * 2 - 1;
        this.posteffect.originalmouse.y = - ( y / this.h ) * 2 + 1;
        this.posteffect.hasMove = true;
      }
  } 

  onTouchStart(event) {
    //event.preventDefault();
     this.checkHint();
     if(this.state.paused){
      this.toggleLoop();
    }

    this.isDown = true;
  } 
  onTouchEnd(event) {
    //event.preventDefault();
    this.isDown = false;
  }  

  onTouchMove(event){
    if(event.target.type != "range"){
      event.preventDefault();
      var off =  this.container.getBoundingClientRect();
                 

      var x = (event.touches[0].clientX - off.left);
      var y = (event.touches[0].clientY - off.top) ;

      this.transformMouse(x,y);
    }
  }

  onMouseMove(event) {
    event.preventDefault();

    var off =  this.container.getBoundingClientRect();

    var x = (event.clientX - off.left);
    var y = (event.clientY - off.top) ;

    this.transformMouse(x,y);   
  }


  onResize() {

    this.w = this.container.offsetWidth;

    this.h = this.container.offsetHeight;

    this.camera.aspect = this.w / this.h;

    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.w , this.h );

    this.posteffect.resize(this.w,this.h);

  }


  onKeyDown(event){
      
    if(event.keyCode == 32){
      this.toggleLoop();
      this.setState({
        showHint : false,
        hintWasVisible : true
      })
    }
  }

  addEvents() {

    this.resizer = (event)=>this.onResize(event);

    if( _assets.isMobile) {

      //this.onTouchStarter = (event)=>this.onTouchStart(event);
      this.onTouchMover = (event)=>this.onTouchMove(event);
      this.onTouchEnder = (event)=>this.onTouchEnd(event);

      //window.addEventListener('touchstart', this.onTouchStarter );
      window.addEventListener('touchmove', this.onTouchMover ,false);
      window.addEventListener('touchend',  this.onTouchEnder ,false);
      window.addEventListener('orientationchange', this.resizer,false);

    }else {

      this.onMouseMover = (event)=>this.onMouseMove(event);
      //this.onMouseDowner = (event)=>this.onMouseDown(event);
      this.onMouseUper = (event)=>this.onMouseUp(event);
      this.onKeyDowner = (event)=>this.onKeyDown(event);

      window.addEventListener('mousemove', this.onMouseMover);
      //window.addEventListener('mousedown', this.onMouseDowner);
      window.addEventListener('mouseup', this.onMouseUper);
      window.addEventListener('keydown', this.onKeyDowner);

    }

    window.addEventListener('resize',this.resizer );
  }

  removeEvents(){

    window.removeEventListener('resize', this.resizer);

    if(_assets.isMobile){
      //window.removeEventListener('touchstart', this.onTouchStarter );
      window.removeEventListener('touchmove', this.onTouchMover );
      window.removeEventListener('touchend',  this.onTouchEnder );
      window.removeEventListener('orientationchange', this.resizer);
    }else{
      window.removeEventListener('mousemove', this.onMouseMover);
      //window.removeEventListener('mousedown', this.onMouseDowner);
      window.removeEventListener('mouseup', this.onMouseUper);
      window.removeEventListener('keydown', this.onKeyDowner);
    }
    
  }

  //__________________________________________________ END OF EVENT
  

  changeForce(){
    this.setState({
      mouse_strength_bool : !this.state.mouse_strength_bool 
    });

    if(this.state.mouse_strength_bool){
      //this.posteffect.options.mouse_strength = 0.055;
      this.posteffect.options.cSize = 660;
    }else{
      //this.posteffect.options.mouse_strength = 0.033;
      this.posteffect.options.cSize = 70;
    }

  }
 

  changeSize(event){
    this.setState({
      cSize_bool : !this.state.cSize_bool
    });
  }

  changeColor(event){
    event.target.blur();
    let currentColor = this.state.color;

    currentColor = currentColor == 5 ? 0 : (currentColor + 1);

    this.setState({
        color: currentColor
    },()=>{
      this.posteffect.changeBG( this.state.color );
      if(this.state.paused){
        this.update();
        cancelAnimationFrame(this.loop);
      
      }
    });

    
  }

  reset(){
    this.posteffect.reset();
    this.setState({
      mouse_strength : 0.033,
      cSize : 70,
      mouse_strength_bool : true,
      cSize_bool : false,
    },()=>{
      this.posteffect.options.mouse_strength = this.state.mouse_strength;
      this.posteffect.options.cSize = this.state.cSize;
    });

    if(this.state.paused){
      this.toggleLoop();
    }
  }

  toggleLoop(){

    if(this.state.paused){
      this.loop = requestAnimationFrame(()=>this.update());
    }else{
      cancelAnimationFrame(this.loop);
    }

    this.setState({
      paused : !this.state.paused
    });
  }


  stopLoop(){
    if(!this.state.paused){
      cancelAnimationFrame(this.loop);
    
      this.setState({
        paused : true
      })
    }
  }

  update(){

    this.loop = requestAnimationFrame(()=>this.update());

		this.posteffectupdate();

	}

	//_________________________________________ 

	render(){


    const backgroundStyle = {
      backgroundColor : bg_colors[this.state.color]
    }

		return (<div className={ "generator-element generator-element-ready-" + this.props.ready }>
        <aside className={"generator-aside isVisible-" + this.state.showSidebar + " mobile-ui-visible-"+ this.state.showMobileUI} >
          <div className="aside-inner">
            <div className="slider-element">
              <button className="generate-share-force desktop-ui" onClick={()=>this.changeForce()}>Toggle force <span className="generate-share-iconset generate-share-force-icon">{this.state.mouse_strength_bool && <Iconset.fluidSoftIcon/>}{!this.state.mouse_strength_bool && <Iconset.fluidHardIcon/>}</span></button>
              <button className="generate-share-color" onClick={(event)=>this.changeColor(event)}>Change color <span className="generate-share-iconset generate-share-color-circle" style={backgroundStyle}></span></button>
              <div className="generate-share-row collapse">
                <button className="generate-share-reset" onClick={()=>this.reset()}>Reset <span className="desktop-ui">fluid</span><span className="generate-share-iconset generate-share-force-icon"><Iconset.fluidResetIcon /></span></button>
                <button className="generate-share-freeze" onClick={()=>this.toggleLoop()}>{!this.state.paused && <span>Freeze</span>}{this.state.paused && <span>Unfreeze</span>}</button>
              </div>
            </div>

            <div className="generate-share">
              <input className="generate-share-title" type="text" placeholder="Add your own title" value={this.props.generator_title} onInput={(event)=>this.props.changeTitle(event)}/>
              <div className="generate-share-row ">
                <button ref={(saveButton) =>{this.saveButton = saveButton}} download="Canvas.png" onClick={()=>this.props.downloadGenerator(this)} className="generate-share-button">Download</button>
                <button onClick={()=>this.props.shareGenerator(this)} className="generate-share-button">Share{_assets.isSafari && !_assets.isMobile && <span className="generate-share-button-tooltip">Allow Pop-Ups<br/>if you can't share.</span>}</button>
              </div>
              <button className="generate-share-submit" onClick={()=>this.props.goToInnerChapterByNumber(1)} style={backgroundStyle} >Continue</button>
            </div>
          </div>
        </aside>
        <div className={"generator-element-canvas generator-element-canvas-ready-"+ this.props.ready} 
          onMouseDown={(event)=>this.onMouseDown(event)} 
          onTouchStart={(event)=>this.onTouchStart(event)}>

          <div className="generator-element-canvas-inner"          
            ref={(container) =>{this.container = container;}}></div>

          <ReactCSSTransitionGroup
            component= "div"
            className="absolute inner-note-space"
            transitionName="fade"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}>
              {this.state.showHint && 
                <div className="space-note desktop-ui" >
                  <h1>press space to freeze the liquid</h1>
                </div>
              }
            </ReactCSSTransitionGroup>
          
        </div>
      </div>);
}
}

export default GeneratorElement;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/generatorElement.js